import townLeft from "@/assets/img/bubble/town-left.png";
import townMiddle from "@/assets/img/bubble/town-middle.png";
import townRight from "@/assets/img/bubble/town-right.png";

import publicLeft from "@/assets/img/bubble/public-left.png";
import publicMiddle from "@/assets/img/bubble/public-middle.png";
import publicRight from "@/assets/img/bubble/public-right.png";

import parkLeft from "@/assets/img/bubble/park-left.png";
import parkMiddle from "@/assets/img/bubble/park-middle.png";
import parkRight from "@/assets/img/bubble/park-right.png";

import businessLeft from "@/assets/img/bubble/business-left.png";
import businessMiddle from "@/assets/img/bubble/business-middle.png";
import businessRight from "@/assets/img/bubble/business-right.png";

import neighborhoodLeft from "@/assets/img/bubble/neighborhood-left.png";
import neighborhoodMiddle from "@/assets/img/bubble/neighborhood-middle.png";
import neighborhoodRight from "@/assets/img/bubble/neighborhood-right.png";

import schoolLeft from "@/assets/img/bubble/school-left.png";
import schoolMiddle from "@/assets/img/bubble/school-middle.png";
import schoolRight from "@/assets/img/bubble/school-right.png";
export const enumAddressName: any = {
  "1": "ZJTYZX",
  "2": "SQJSYD",
  "3": "YQTYCS",
  "4": "SQTYMD",
  "5": "JWZHHDS",
  "6": "XXYDCS"
}

export const tabColors: any = {
  "1": "#FF8F00",
  "2": "#1A8FF0",
  "3": "#F0B91A",
  "4": "#EF396C",
  "5": "#C02B2B",
  "6": "#FF6F6F"
}

export const bubbleEnum: any = {
  "1": { left: townLeft, middle: townMiddle, right: townRight },
  "2": { left: publicLeft, middle: publicMiddle, right: publicRight },
  "3": { left: parkLeft, middle: parkMiddle, right: parkRight },
  "4": { left: businessLeft, middle: businessMiddle, right: businessRight },
  "5": { left: neighborhoodLeft, middle: neighborhoodMiddle, right: neighborhoodRight },
  "6": { left: schoolLeft, middle: schoolMiddle, right: schoolRight }
}